import classnames from 'classnames';
import Icon from 'components/ui/icon';
import { Skeleton } from 'components/ui/skeleton';

interface Props {
  title?: string;
  iconName?: string;
  isNew?: boolean;
  isLoading?: boolean;
  isDraggable?: boolean;
  isOverlay?: boolean;
  isExpanded?: boolean;
  onClick?: () => void;
}

export const QuickActionCard: React.FC<Props> = ({
  title = '',
  iconName = '',
  isNew = false,
  isLoading = false,
  isDraggable = false,
  isOverlay = false,
  isExpanded = false,
  onClick,
}) => {
  if (isLoading) {
    return (
      <div className='card p-4 flex flex-col justify-between w-full h-[136px] max-mobile-s:h-[130px] select-none border border-transparent cursor-pointer'>
        <Skeleton height={40} width={40} style={{ borderRadius: '100%' }} />
        <Skeleton height={14} />
      </div>
    );
  }

  return (
    <div
      className={classnames(
        'card p-4 flex flex-col justify-between w-full h-[136px] max-mobile-s:h-[130px] select-none border border-transparent cursor-pointer',
        {
          'bg-background-tertiary!': isNew,
          'cursor-grabbing shadow-[0px_10px_10px_0px_rgba(0,0,0,0.2)]':
            isOverlay,
          'touch-none cursor-grab hover:border hover:border-brand-main': isDraggable,
          'flex flex-row items-center justify-start gap-3 h-[80px]': isExpanded,
        }
      )}
      onClick={onClick}>
      {isDraggable ? (
        <Icon
          name='draggable'
          size={16}
          className='absolute top-4 right-4 scale-110'
        />
      ) : null}
      <div
        className={classnames('w-10 h-10 rounded-full bg-background-base text-brand-main flex justify-center items-center shrink-0', {
          'bg-background-primary text-text-secondary': isNew,
        })}>
        <Icon name={iconName} size={20} />
      </div>
      <h5
        className={classnames('text-m-medium', {
          'text-text-secondary': isNew,
        })}>
        {title}
      </h5>
    </div>
  );
};
